import {
    WIS_RPC_COMMANDS,
    WIS_RPC_MESSAGE
} from '../constants';

import executeWisRpc from './executeWisRpc';

/**
 * Check if host contains https://
 *
 * @param host
 * @return {*}
 */
function normalizeHost(host = '') {
    if (host.match('https://')) {
        return host.slice(8);
    }

    return host;
}

/**
 * Send authorization data to the WIService
 * @param socket
 */
export default function authorizeWis(socket) {
    const { pbxVersion: version = '', pbxSerial: pbxId = '', pbxHost = '', pbxExtension = '' } = config;
    const { displayName: userName = '', email: userEmail = '' } = APP.store.getState()['features/base/settings'];

    const rpcCommand = {
        message: WIS_RPC_MESSAGE.WISERVICE,
        msgdata: {
            command: WIS_RPC_COMMANDS.AUTHORIZE,
            msgdata: {
                app: 'Wizyconf',
                version,
                pbx: {
                    hostname: pbxId ? normalizeHost(pbxHost) : '',
                    port: '',
                    secure: true,
                    serial: pbxId
                },
                user: {
                    name: userName || '',
                    extension: pbxExtension || '',
                    email: userEmail || '',
                    mobile: '',
                    lang: 'en'
                },
                userAgent: navigator.userAgent,
                platform: navigator.userAgentData?.platform || '',
                userLicenseType: ''
            }
        }
    };

    executeWisRpc(socket, rpcCommand);
}
